/**
 * Resolved color palettes for React Native.
 *
 * The design handoff's theme.css (see tokens.ts) expresses every color in oklch()
 * with color-mix() derivations — neither of which React Native's StyleSheet supports.
 * These maps are those exact tokens resolved to sRGB hex (oklch → linear sRGB → gamma,
 * color-mix computed in oklab), so native and web render the same palette.
 *
 * Keys mirror the CSS custom-property names (--paper → paper, --line-strong → lineStrong).
 */

export interface Palette {
  paper: string;
  paper2: string;
  paper3: string;
  card: string;
  ink: string;
  ink2: string;
  ink3: string;
  ink4: string;
  line: string;
  lineStrong: string;
  accent: string;
  accentInk: string;
  accentSoft: string;
  accentLine: string;
  info: string;
  infoSoft: string;
  infoLine: string;
  success: string;
  successSoft: string;
  successLine: string;
  warn: string;
  warnSoft: string;
  warnLine: string;
  danger: string;
  dangerSoft: string;
  dangerLine: string;
  neutral: string;
  neutralSoft: string;
  neutralLine: string;
}

export const LIGHT: Palette = {
  paper: '#fbfaf8',
  paper2: '#f6f5f2',
  paper3: '#f1f0ec',
  card: '#ffffff',
  ink: '#13161a',
  ink2: '#3e4348',
  ink3: '#6d7277',
  ink4: '#a1a5a9',
  line: '#e3e5e7',
  lineStrong: '#cbced1',
  accent: '#2b64c3',
  accentInk: '#023481',
  accentSoft: '#e6f3ff',
  accentLine: '#bad2f9',
  info: '#0f74c5',
  infoSoft: '#def5ff',
  infoLine: '#aac4df',
  success: '#007834',
  successSoft: '#d8f9dd',
  successLine: '#a8c4b0',
  warn: '#be7125',
  warnSoft: '#ffeec5',
  warnLine: '#dac2b1',
  danger: '#b14e49',
  dangerSoft: '#ffe8e4',
  dangerLine: '#d8b8b6',
  neutral: '#008892',
  neutralSoft: '#d4fbfc',
  neutralLine: '#a0c9cd',
};

export const DARK: Palette = {
  paper: '#101214',
  paper2: '#191b1d',
  paper3: '#222427',
  card: '#1d1f23',
  ink: '#f4f3f0',
  ink2: '#c5c4c0',
  ink3: '#8d8c89',
  ink4: '#646360',
  line: '#303337',
  lineStrong: '#4a4d53',
  accent: '#62a2ff',
  accentInk: '#9ad2ff',
  accentSoft: '#182d50',
  accentLine: '#274b88',
  info: '#6dbdff',
  infoSoft: '#072a4a',
  infoLine: '#445a71',
  success: '#76cf8a',
  successSoft: '#092c13',
  successLine: '#465e50',
  warn: '#fba962',
  warnSoft: '#472400',
  warnLine: '#685547',
  danger: '#f98f87',
  dangerSoft: '#47211e',
  dangerLine: '#694e4e',
  neutral: '#3aced6',
  neutralSoft: '#002b2d',
  neutralLine: '#3d5e63',
};
